import { createContext, PropsWithChildren, useContext } from "react";
import { CentraAllocationRuleResponseV1 } from "@made-people/nestjs-bff-service";

export interface AllocationRuleContextValue {
  allocationRule: CentraAllocationRuleResponseV1 | null;
  isLoading: boolean;
  hasError: boolean;
}

const AllocationRuleContext = createContext<
  AllocationRuleContextValue | undefined
>(undefined);

export interface MmAllocationRuleProviderProps {
  allocationRule: CentraAllocationRuleResponseV1 | null;
  isLoading: boolean;
  hasError: boolean;
}

export const MmAllocationRuleProvider = ({
  children,
  allocationRule,
  isLoading,
  hasError,
}: PropsWithChildren<MmAllocationRuleProviderProps>) => {
  return (
    <AllocationRuleContext.Provider
      value={{ allocationRule, isLoading, hasError }}
    >
      {children}
    </AllocationRuleContext.Provider>
  );
};

export const useAllocationRule = (): AllocationRuleContextValue => {
  const context = useContext(AllocationRuleContext);
  if (!context) {
    throw new Error(
      "useAllocationRule must be used within MmAllocationRuleProvider",
    );
  }
  return context;
};
